import { Box, Button, FormControl, FormHelperText, Stack } from "@mui/material";
import { useState } from "react";

import { ArrayHelper } from "@/common/helpers/array";
import { ApiEnumName } from "@/common/services/enum";
import { ScheduleEntryEntityType } from "@/core/api/generated/v1";

import ApiEnumsAutocomplete from "../../Enum/ApiEnumsAutocomplete";
import AppPopoverActions from "../../Popover/AppPopoverActions";

export interface VehicleScheduleEntryFilters {
  entityTypes?: ScheduleEntryEntityType[];
}

interface Props {
  defaultValue: VehicleScheduleEntryFilters | null;
  onCancel: () => void;
  onSave: (value: VehicleScheduleEntryFilters | null) => void;
}

export function VehicleScheduleEntryFiltersInput({ defaultValue, onCancel, onSave }: Props) {
  const [value, setValue] = useState<VehicleScheduleEntryFilters | null>(defaultValue);

  return (
    <Stack gap={2}>
      <Box>
        <FormControl fullWidth margin='dense'>
          <ApiEnumsAutocomplete
            type={ApiEnumName.ScheduleEntryEntityType}
            label='Entity types'
            size='small'
            values={value?.entityTypes || []}
            onChange={(newValues) => {
              setValue((prev) => ({
                ...prev,
                entityTypes: ArrayHelper.undefinedIfEmpty(newValues),
              }));
            }}
          />
          <FormHelperText>Leave empty to view all.</FormHelperText>
        </FormControl>
      </Box>

      <AppPopoverActions
        primaryActions={
          <>
            <Button variant='outlined' size='small' color='text' onClick={onCancel}>
              Cancel
            </Button>
            <Button variant='contained' size='small' color='primary' onClick={() => onSave(value)}>
              Save
            </Button>
          </>
        }
        secondaryActions={
          <>
            <Button variant='text' size='small' color='text' onClick={() => setValue(null)}>
              Reset
            </Button>
          </>
        }
      />
    </Stack>
  );
}
